module.exports = __webpack_public_path__ + "static/img/outwork-black.dc6b847.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outwork-black.png
// module id = HLqp
// module chunks = 62